import React from "react";
import styled from "styled-components";

const CenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 100%;
  font-family: ${({ theme }) => theme.fonts};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.color?.users?.[0] || '#666'};
  opacity: 0.7;
`;

export const EmptyData = () => {
  return <CenteredContainer>No data</CenteredContainer>;
}